import { useDispatch, useSelector } from "react-redux";
import { toggleFraseConfirmacionActiveThunk } from "../../store/reducers/frasesConfirmacion/frasesConfirmacion.thunks";
import Modal from "../UI/Modal";
import Loader from "../UI/Loader";
import { closeConfirmToggle } from "../../store/reducers/frasesConfirmacion/frasesConfirmacion.reducer";

const ConfirmToggleModal = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, toggleFraseId, toggling } = useSelector(
    (state) => state.frasesConfirmacion
  );

  const frase = useSelector((state) =>
    state.frasesConfirmacion.list.find((f) => f.id === toggleFraseId)
  );

  const handleConfirm = () => {
    dispatch(toggleFraseConfirmacionActiveThunk(toggleFraseId));
  };

  return (
    <Modal
      open={confirmModalOpen}
      onClose={() => dispatch(closeConfirmToggle())}
      title="Confirmación"
      size="sm"
    >
      {toggling ? (
        <Loader center text="Actualizando frase..." type="dots" size="sm" />
      ) : (
        <>
          <p className="mb-3">
            ¿Seguro que quieres{" "}
            <strong>{frase?.is_active ? "desactivar" : "activar"}</strong> la
            frase <strong>"{frase?.frase}"</strong>?
          </p>

          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => dispatch(closeConfirmToggle())}
            >
              Cancelar
            </button>

            <button className="btn btn-primary" onClick={handleConfirm}>
              Confirmar
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleModal;
